import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'nome'
})

export class NomePipe implements PipeTransform {

  transform(value: any): any {
    const array = value.split(' ');
    let nome: any;
    let sobrenome: any;
    if (array) {
      nome = array[0];
      if (array.length > 1){
        sobrenome = array[(array.length - 1)];
        return nome + ' ' + sobrenome;
      } else {
        return nome;
      }
    }
  }
}